export default function IconDelete(props: Icon) {
  const { height, width, className } = props;
  return (
    <svg
      className={className}
      aria-hidden="true"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height : 18}
      height={height ? height : width ? width : 18}
      viewBox="0 -960 960 960"
    >
      <path
        fill="currentColor"
        d="M277.37-111.869q-37.783 0-64.392-26.609-26.609-26.609-26.609-64.392v-514.5h-45.5v-91H354.5v-45.5h250.522v45.5h214.109v91h-45.5v514.5q0 37.783-26.609 64.392-26.609 26.609-64.392 26.609H277.37ZM682.63-717.37H277.37v514.5h405.26v-514.5ZM355.696-280.239h85.5v-360h-85.5v360Zm163.108 0h85.5v-360h-85.5v360ZM277.37-717.37v514.5-514.5Z"
      />
    </svg>
  );
}
